(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9912,4348],{

/***/ 965700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);


var LoaderIcon = function(props) {
    var waterSplashLoader = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "waterSplashLoader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var ellipsis = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "ds-ellipsis-loader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var _renderLoader = function(type) {
        switch(type){
            case "water_splash_loader":
                return waterSplashLoader();
            case "ellipsis":
            default:
                return ellipsis();
        }
    };
    return _renderLoader(props.type || "");
};
/* harmony default export */ __webpack_exports__["Z"] = (LoaderIcon);


/***/ }),

/***/ 121910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "InstagramReels": function() { return /* binding */ InstagramReels; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/videoUtility.js
var videoUtility = __webpack_require__(964582);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/constant.ts
var constant = __webpack_require__(431308);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(179220);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useLoadVisibleReel.ts
var useLoadVisibleReel = __webpack_require__(50722);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(721023);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/InstagramReels/InstagramVideoComp.tsx







var InstagramVideoComp = function(props) {
    var ref, ref1;
    var oneGridCellGeometry = props.oneGridCellGeometry, post = props.post, index = props.index, videoRef = props.videoRef;
    var ref2 = (0,react.useState)(false), loadVideo = ref2[0], setLoadVideo = ref2[1];
    var ref3 = (0,react.useState)(false), isVideoDownloaded = ref3[0], setIsVideoDownloaded = ref3[1];
    // const [shouldMuteVideo, setShouldMuteVideo] = useState(true);
    (0,useLoadVisibleReel/* useLoadVisibleReel */.c)({
        videoRef: videoRef,
        reelIndex: index,
        setLoadVideo: setLoadVideo,
        loadVideo: loadVideo
    });
    var ref4 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref4.widgetContextState.globalStyle;
    var handleMouseEnter = function() {
        var ref;
        videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef[index]) === null || ref === void 0 ? void 0 : ref.play();
    };
    var handleMouseLeave = function() {
        var ref;
        videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef[index]) === null || ref === void 0 ? void 0 : ref.pause();
        videoRef[index].currentTime = 0;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-relative",
        children: [
            !isVideoDownloaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-absolute tw-left-1/2 tw-top-1/2 tw-z-[4] -tw-translate-x-1/2 -tw-translate-y-1/2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                    type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.appLoader) === null || ref === void 0 ? void 0 : ref.loaderId) || "ellipsis",
                    color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                title: "Click to see full video",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    ref: function(node) {
                        return videoRef[index] = node;
                    },
                    style: {
                        width: oneGridCellGeometry.width + "px",
                        height: oneGridCellGeometry.height + "px",
                        minWidth: oneGridCellGeometry.width + "px"
                    },
                    className: classnames_default()("tw-h-full tw-w-full tw-bg-black tw-object-cover"),
                    loop: true,
                    playsInline: true,
                    muted: true,
                    onLoadedData: function() {
                        return setIsVideoDownloaded(true);
                    },
                    src: loadVideo ? post : undefined,
                    onMouseEnter: handleMouseEnter,
                    onMouseLeave: handleMouseLeave
                })
            })
        ]
    });
};
/* harmony default export */ var InstagramReels_InstagramVideoComp = (InstagramVideoComp);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(496664);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(922004);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/isMobileDevice.ts
var isMobileDevice = __webpack_require__(826910);
// EXTERNAL MODULE: ./src/components/ProductScheduler/utils.ts
var utils = __webpack_require__(897713);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Chevrons/ChevronTypes/ChevronType1/index.tsx
var ChevronType1 = __webpack_require__(51087);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Arrows/index.tsx + 1 modules
var Arrows = __webpack_require__(601523);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/InstagramReels/RenderInstaModal.tsx











var RenderInstaModal = function(props) {
    var handleNextClick = function handleNextClick(post) {
        if ((post === null || post === void 0 ? void 0 : post.length) - 1 > currentSlideActive) {
            var ref;
            (ref = carouselRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
                top: 0,
                left: 680,
                behavior: "smooth"
            });
            setCurrentSlideActive(function(prev) {
                return prev + 1;
            });
        }
    };
    var handlePrevClick = function handlePrevClick() {
        if (currentSlideActive > 0) {
            var ref;
            (ref = carouselRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
                top: 0,
                left: -680,
                behavior: "smooth"
            });
            setCurrentSlideActive(function(prev) {
                return prev - 1;
            });
        }
    };
    var handleClose = function handleClose() {
        setConfig(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                showModal: false
            });
        });
    };
    var renderImage = function renderImage(post) {
        var imageStyle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: post,
            loading: "lazy",
            style: (0,_object_spread/* default */.Z)({}, imageStyle),
            className: "tw-object-contain tw-bg-black ".concat(!isMobile ? "tw-max-w-[680px] tw-h-[100%] tw-rounded-tl-[12px] tw-rounded-bl-[12px]" : "tw-max-h-[400px] tw-w-[100%] tw-flex tw-items-center", " removeGlobalOverride imgWrapperGlobalStyle globalImgStyleConsumer")
        });
    };
    var renderVideo = function renderVideo(postData) {
        var videoStyle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex tw-bg-black ".concat(!isMobile ? "tw-flex-col tw-justify-center tw-h-[100%] tw-rounded-tl-[12px] tw-rounded-bl-[12px]" : "tw-items-center tw-max-h-[400px] tw-w-[100%] tw-flex", " tw-object-contain tw-bg-black"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), (0,_object_spread/* default */.Z)({
                url: postData,
                controls: true,
                width: "100%",
                playing: true,
                style: (0,_object_spread/* default */.Z)({
                    maxHeight: !isMobile ? "600px" : "492px",
                    maxWidth: !isMobile ? "680px" : "100%",
                    borderRadius: !isMobile ? "12px 0 0 12px" : "",
                    overflow: !isMobile ? "hidden" : ""
                }, isMobile ? {
                    display: "flex"
                } : {})
            }, !isMobile ? {
                height: "100%"
            } : "", videoStyle))
        });
    };
    var getMaxHeight = function getMaxHeight() {
        var ref;
        return (mobilePostRef === null || mobilePostRef === void 0 ? void 0 : (ref = mobilePostRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) || "";
    };
    var renderImageAndVideo = function renderImageAndVideo(config) {
        var ref, ref1, ref2, ref3;
        var mediaUrl = config === null || config === void 0 ? void 0 : (ref = config.post) === null || ref === void 0 ? void 0 : (ref1 = ref.parent_media) === null || ref1 === void 0 ? void 0 : ref1.media_url;
        if (config === null || config === void 0 ? void 0 : (ref2 = config.post) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.child_media) === null || ref3 === void 0 ? void 0 : ref3.length) {
            var ref4, ref5, ref6, ref7;
            var style = {
                maxWidth: isMobile ? "768px" : "680px",
                maxHeight: isMobile ? "100%" : "600px",
                height: isMobile ? "400px" : "600px",
                width: isMobile ? mobilePostRef === null || mobilePostRef === void 0 ? void 0 : (ref4 = mobilePostRef.current) === null || ref4 === void 0 ? void 0 : ref4.clientWidth : "680px"
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-relative ".concat(isMobile ? "tw-w-[100%] tw-h-[400px]" : "tw-w-max tw-h-max"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: carouselRef,
                    style: {
                        overflow: "auto visible"
                    },
                    className: "no-scrollbar tw-flex ".concat(!isMobile ? "tw-w-[680px] tw-h-[600px] tw-rounded-tl-[12px] tw-rounded-bl-[12px]" : "tw-w-[100%] tw-h-[400px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10 tw-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronType1.ChevronType1, {
                                showArrows: !isMobile,
                                showChevrons: true,
                                handlePrevClick: handlePrevClick,
                                handleNextClick: function() {
                                    var ref;
                                    return handleNextClick(config === null || config === void 0 ? void 0 : (ref = config.post) === null || ref === void 0 ? void 0 : ref.child_media);
                                },
                                isAutoPlayOn: false,
                                currentActiveSlideIndex: currentSlideActive,
                                chevronAnimationTiming: 0,
                                arrowPosition: "center",
                                images: config === null || config === void 0 ? void 0 : (ref5 = config.post) === null || ref5 === void 0 ? void 0 : ref5.child_media,
                                bgOpacity: 1,
                                height: 24,
                                width: 24,
                                isShadowTypeIcon: true,
                                arrowColor: "#111C36",
                                arrowType: "v1",
                                showGradient: true,
                                containerClass: isMobile ? "!tw-px-[12px]" : "!tw-px-[24px]"
                            })
                        }),
                        config === null || config === void 0 ? void 0 : (ref6 = config.post) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.child_media) === null || ref7 === void 0 ? void 0 : ref7.map(function(childData) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex tw-bg-black tw-items-center tw-justify-items-center tw-w-[100%]",
                                children: (0,videoUtility/* isVideoUrl */.cb)(childData === null || childData === void 0 ? void 0 : childData.media_url) ? renderVideo(childData === null || childData === void 0 ? void 0 : childData.media_url, style) : renderImage(childData === null || childData === void 0 ? void 0 : childData.media_url, style)
                            }, childData === null || childData === void 0 ? void 0 : childData.media_url);
                        })
                    ]
                })
            });
        }
        return config.type === "image" ? renderImage(mediaUrl) : renderVideo(mediaUrl);
    };
    var renderProfile = function renderProfile() {
        var userDetails = config.userDetails;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                borderBottom: "1px solid #E6E6E6"
            },
            className: "tw-px-[16px] tw-py-[12px] ".concat(isMobile ? "tw-bg-[#FFFFFF] tw-max-w-[768px]" : "tw-w-[100%]"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: userDetails === null || userDetails === void 0 ? void 0 : userDetails.profile_picture_url,
                        height: "40px",
                        width: "40px",
                        className: "tw-rounded-[100px] tw-object-cover"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-text-[14px] tw-font-medium tw-text-newBlack",
                        children: userDetails === null || userDetails === void 0 ? void 0 : userDetails.username
                    })
                ]
            })
        });
    };
    var renderContent = function renderContent() {
        var ref;
        var parentMedia = config === null || config === void 0 ? void 0 : (ref = config.post) === null || ref === void 0 ? void 0 : ref.parent_media;
        var caption = parentMedia === null || parentMedia === void 0 ? void 0 : parentMedia.caption;
        var postDate = (0,utils/* formatDate */.p6)(parentMedia === null || parentMedia === void 0 ? void 0 : parentMedia.timestamp);
        var showTrimedContent = (caption === null || caption === void 0 ? void 0 : caption.length) > 140;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-bg-white ".concat(!isMobile ? "tw-w-[358px] tw-max-w-[358px] tw-rounded-tr-[12px] tw-rounded-br-[12px] tw-h-[100%]" : "tw-w-[100%] tw-max-w-[768px] tw-h-max tw-relative"),
            children: [
                !isMobile && renderProfile(),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-py-[24px] tw-px-[16px] tw-text-[14px] tw-font-normal tw-leading-[1.4]",
                    children: [
                        showTrimedContent && showReadMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(caption === null || caption === void 0 ? void 0 : caption.substring(0, 140), " ... ")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: caption
                        }),
                        showReadMore && showTrimedContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: function() {
                                return setShowReadMore(false);
                            },
                            className: "tw-text-[14px] tw-font-semibold tw-text-newBlack tw-cursor-pointer",
                            children: "Read more"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-py-[24px] tw-px-[16px] tw-text-[14px] tw-font-normal tw-leading-[1.4] tw-max-h-[480px] tw-overflow-scroll",
                    children: caption
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-text-[13px] tw-font-normal tw-text-newBlack tw-opacity-70 tw-px-[16px] ".concat(!isMobile ? "tw-absolute tw-bottom-[16px]" : "tw-pb-[16px]"),
                    children: postDate
                })
            ]
        });
    };
    var renderCloseIcon = function renderCloseIcon() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: handleClose,
            className: "ic-cross-bg-black-lg wb-sprite ".concat(isMobile ? "tw-absolute tw-top-[-50px] tw-right-[44%]" : " tw-fixed  tw-top-[20px] tw-right-[20px]")
        });
    };
    var config = props.config, setConfig = props.setConfig, handlePrevPost = props.handlePrevPost, handleNextPost = props.handleNextPost;
    var ref = (0,react.useState)(true), showReadMore = ref[0], setShowReadMore = ref[1];
    var carouselRef = (0,react.useRef)(null);
    var isMobile = (0,isMobileDevice/* isMobileDevice */.s)();
    var mobilePostRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(0), currentSlideActive = ref1[0], setCurrentSlideActive = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: config.showModal,
        className: "".concat(!isMobile ? "tw-flex tw-items-center tw-flex-col tw-justify-center" : "tw-flex tw-flex-col tw-justify-end", " tw-bg-[#00000033]"),
        slotProps: {
            backdrop: {
                sx: {
                    background: "##000000b3"
                }
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: !isMobile ? "tw-flex tw-items-center tw-h-[100%] tw-w-[1200px]" : "",
            children: [
                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrows/* ArrowIcon */.e, {
                    onClick: handlePrevPost,
                    arrowDirection: "left",
                    arrowType: "v1",
                    imageProps: {
                        className: "tw-mr-[10px]",
                        bgColor: "white",
                        arrowColor: "black",
                        bgOpacity: 1,
                        width: 48,
                        height: 48
                    }
                }),
                !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-rounded-[12px] tw-h-[90%] tw-max-h-[600px] tw-mx-auto tw-flex tw-relative",
                    children: [
                        renderImageAndVideo(config),
                        renderContent(),
                        renderCloseIcon()
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-rounded-[12px] tw-max-w-[768px] tw-relative",
                    children: [
                        renderProfile(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                maxHeight: getMaxHeight()
                            },
                            ref: mobilePostRef,
                            className: "tw-flex tw-flex-col tw-overflow-scroll",
                            children: [
                                renderImageAndVideo(config),
                                renderContent(),
                                renderCloseIcon()
                            ]
                        })
                    ]
                }),
                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrows/* ArrowIcon */.e, {
                    onClick: handleNextPost,
                    arrowDirection: "right",
                    arrowType: "v1",
                    imageProps: {
                        className: "tw-ml-[10px]",
                        bgColor: "white",
                        arrowColor: "black",
                        bgOpacity: 1,
                        width: 48,
                        height: 48
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var InstagramReels_RenderInstaModal = (RenderInstaModal);

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/utils.ts
var components_utils = __webpack_require__(575646);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(409669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/config/endpoints.js
var endpoints = __webpack_require__(951919);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/InstagramReels/constant.ts
var MEDIA_TYPE = {
    VIDEO: "video",
    IMAGE: "image"
};
var ACTION_TYPE = {
    PREVIOUS: "prev",
    NEXT: "next"
};

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/ListPresentationContext.tsx + 15 modules
var ListPresentationContext = __webpack_require__(101657);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/InstagramReels/InstagramReels.tsx


















function InstagramReels() {
    var showZigZaglayout = function showZigZaglayout() {
        if (isMobile && listPresentationConfig.numColumnsMobile === 1) {
            return false;
        }
        return true;
    };
    var checkForIndexing = function checkForIndexing(index) {
        if (!isMobile && listPresentationConfig.layoutType === constant/* CONTAINER_TYPE.GRID */.an.GRID) {
            var currentIndexOfImage = index % listPresentationConfig.numColumnsDesktop;
            if (currentIndexOfImage % 2 !== 0) {
                return true;
            }
            return false;
        } else if (index % 2 === 0) {
            return false;
        }
        return true;
    };
    var handleMediaClick = function handleMediaClick(post, type, index) {
        var updatedModalConfig = (0,_object_spread/* default */.Z)({}, modalConfig);
        updatedModalConfig.post = post;
        updatedModalConfig.showModal = true;
        updatedModalConfig.type = type;
        updatedModalConfig.userDetails = instaDataFromApi === null || instaDataFromApi === void 0 ? void 0 : instaDataFromApi.user;
        updatedModalConfig.currIndex = index;
        setModalConfig(updatedModalConfig);
    };
    var handleModalPost = function handleModalPost(type) {
        var ref;
        var updatedModalConfig = (0,_object_spread/* default */.Z)({}, modalConfig);
        var currIndex = updatedModalConfig.currIndex;
        if (type === ACTION_TYPE.PREVIOUS && currIndex >= 1) {
            var ref1, ref2, ref3;
            var currentPost = instaDataFromApi === null || instaDataFromApi === void 0 ? void 0 : (ref1 = instaDataFromApi.media) === null || ref1 === void 0 ? void 0 : ref1[currIndex - 1];
            var _$type = (0,videoUtility/* isVideoUrl */.cb)(currentPost === null || currentPost === void 0 ? void 0 : (ref2 = currentPost.parent_media) === null || ref2 === void 0 ? void 0 : ref2.media_url) ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.IMAGE;
            if (currentPost === null || currentPost === void 0 ? void 0 : (ref3 = currentPost.child_media) === null || ref3 === void 0 ? void 0 : ref3.length) {
                handleMediaClick(currentPost, "", currIndex - 1);
            } else {
                handleMediaClick(currentPost, _$type, currIndex - 1);
            }
        } else if (type === ACTION_TYPE.NEXT && currIndex < (instaDataFromApi === null || instaDataFromApi === void 0 ? void 0 : (ref = instaDataFromApi.media) === null || ref === void 0 ? void 0 : ref.length) - 1) {
            var ref4, ref5, ref6;
            var currentPost1 = instaDataFromApi === null || instaDataFromApi === void 0 ? void 0 : (ref4 = instaDataFromApi.media) === null || ref4 === void 0 ? void 0 : ref4[currIndex + 1];
            var _$type1 = (0,videoUtility/* isVideoUrl */.cb)(currentPost1 === null || currentPost1 === void 0 ? void 0 : (ref5 = currentPost1.parent_media) === null || ref5 === void 0 ? void 0 : ref5.media_url) ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.IMAGE;
            if (currentPost1 === null || currentPost1 === void 0 ? void 0 : (ref6 = currentPost1.child_media) === null || ref6 === void 0 ? void 0 : ref6.length) {
                handleMediaClick(currentPost1, "", currIndex + 1);
            } else {
                handleMediaClick(currentPost1, _$type1, currIndex + 1);
            }
        }
    };
    var renderImages = function renderImages(url, post, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: function() {
                return handleMediaClick(post, MEDIA_TYPE.IMAGE, index);
            },
            className: "tw-h-[100%] tw-w-[100%]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                width: "100%",
                loading: "lazy",
                height: "100%",
                src: url,
                className: "tw-h-full tw-w-full tw-max-w-full tw-object-cover"
            })
        });
    };
    var renderVideos = function renderVideos(url, index, post) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: function() {
                return handleMediaClick(post, MEDIA_TYPE.VIDEO, index);
            },
            className: "tw-h-[100%] tw-w-[100%]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstagramReels_InstagramVideoComp, {
                oneGridCellGeometry: oneGridCellGeometry,
                post: url,
                index: index,
                videoRef: videoRefs
            })
        });
    };
    var ref, ref1, ref2;
    var data = (0,ListPresentationContext/* useListPresentationContextData */.ds)();
    var _state = data.state, isMobile = _state.isMobile, listPresentationConfig = _state.listPresentationConfig;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, oneGridCellGeometry = _generalValues.oneGridCellGeometry, containerTracks = _generalValues.containerTracks, isLayoutCarousel = _generalValues.isLayoutCarousel;
    var storeId = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeId: state.storeReducer.store.store_id
        };
    }).storeId;
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), authToken = ref3.authToken, _widgetContextState = ref3.widgetContextState, fetchingInstaData = _widgetContextState.fetchingInstaData, globalStyle = _widgetContextState.globalStyle, setInstaUserDetail = ref3.widgetContextActions.setInstaUserDetail;
    var videoRefs = (0,react.useRef)({});
    var ref4 = (0,react.useState)({
        showModal: false,
        post: {},
        type: "",
        userDetails: {},
        currIndex: 0
    }), modalConfig = ref4[0], setModalConfig = ref4[1];
    var ref5 = (0,react.useState)({
        media: [],
        user: {}
    }), instaDataFromApi = ref5[0], setInstaDataFromApi = ref5[1];
    var isLayout2 = listPresentationConfig.layoutName === constant/* LAYOUT_TYPE.layout2 */.yP.layout2;
    var numOfItemToShow = (containerTracks === null || containerTracks === void 0 ? void 0 : containerTracks.numColumns) * (containerTracks === null || containerTracks === void 0 ? void 0 : containerTracks.numRows);
    var updatedInstaData = isLayoutCarousel ? instaDataFromApi === null || instaDataFromApi === void 0 ? void 0 : instaDataFromApi.media : instaDataFromApi === null || instaDataFromApi === void 0 ? void 0 : (ref = instaDataFromApi.media) === null || ref === void 0 ? void 0 : ref.slice(0, numOfItemToShow);
    function getInstaDataFromApi() {
        return _getInstaDataFromApi.apply(this, arguments);
    }
    function _getInstaDataFromApi() {
        _getInstaDataFromApi = (0,_async_to_generator/* default */.Z)(function() {
            var apiHeader, instaApiForCfe, ref, response, updatedResponse, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        apiHeader = (0,components_utils/* commonApiHeader */.Ju)(authToken);
                        instaApiForCfe = endpoints/* ENDPOINT.INSTAGRAM.getInstaDataOnCfe */.f.INSTAGRAM.getInstaDataOnCfe(storeId);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios_default().get(instaApiForCfe, apiHeader)
                        ];
                    case 2:
                        response = _state.sent();
                        updatedResponse = JSON.parse(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data);
                        setInstaUserDetail(updatedResponse || {});
                        setInstaDataFromApi(updatedResponse);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        (0,Toast/* toastNotifyError */.Lu)(err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _getInstaDataFromApi.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        getInstaDataFromApi();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !fetchingInstaData ? updatedInstaData === null || updatedInstaData === void 0 ? void 0 : updatedInstaData.map(function(post, index) {
                var ref, ref1, ref2;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: oneGridCellGeometry.width + "px",
                            height: oneGridCellGeometry.height + "px",
                            minWidth: oneGridCellGeometry.width + "px"
                        },
                        className: "".concat(isLayout2 && showZigZaglayout() ? checkForIndexing(index) ? "tw-relative tw-bottom-20" : "" : ""),
                        children: (0,videoUtility/* isVideoUrl */.cb)(post === null || post === void 0 ? void 0 : (ref = post.parent_media) === null || ref === void 0 ? void 0 : ref.media_url) ? renderVideos(post === null || post === void 0 ? void 0 : (ref1 = post.parent_media) === null || ref1 === void 0 ? void 0 : ref1.media_url, index, post) : renderImages(post === null || post === void 0 ? void 0 : (ref2 = post.parent_media) === null || ref2 === void 0 ? void 0 : ref2.media_url, post, index)
                    }, index)
                });
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.loaderId) || "ellipsis",
                color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.appLoader) === null || ref2 === void 0 ? void 0 : ref2.color
            }),
            modalConfig.showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(InstagramReels_RenderInstaModal, {
                config: modalConfig,
                setConfig: setModalConfig,
                handlePrevPost: function() {
                    return handleModalPost(ACTION_TYPE.PREVIOUS);
                },
                handleNextPost: function() {
                    return handleModalPost(ACTION_TYPE.NEXT);
                }
            })
        ]
    });
}


/***/ }),

/***/ 575646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Im": function() { return /* binding */ getMappedproductsTextSize; },
/* harmony export */   "Ju": function() { return /* binding */ commonApiHeader; },
/* harmony export */   "TI": function() { return /* binding */ getMappedProductCasing; },
/* harmony export */   "aA": function() { return /* binding */ getMappedProductTextThickness; },
/* harmony export */   "sz": function() { return /* binding */ getMappedProductTextAlign; }
/* harmony export */ });
/* unused harmony export getTextSizeNum */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

function getMappedproductsTextSize(sizeString) {
    var style = {};
    switch(sizeString){
        case "extraSmall":
            style.fontSize = "12px";
            style.lineHeight = "1.4";
            break;
        case "small":
            style.fontSize = "13px";
            style.lineHeight = "1.4";
            break;
        case "regular":
            style.fontSize = "14px";
            style.lineHeight = "1.4";
            break;
        case "medium":
            style.fontSize = "16px";
            style.lineHeight = "1.4";
            break;
        case "large":
            style.fontSize = "18px";
            style.lineHeight = "1.4";
            break;
        case "extraLarge":
            style.fontSize = "20px";
            style.lineHeight = "1.4";
            break;
        default:
            style.fontSize = "14px";
            style.lineHeight = "1.4";
            break;
    }
    return style;
}
function getMappedProductTextAlign(xAlignment) {
    var styles = {};
    switch(xAlignment){
        case "left":
            styles.textAlign = "left";
            break;
        case "center":
            styles.textAlign = "center";
            break;
        case "right":
            styles.textAlign = "right";
            break;
    }
    return styles;
}
function getMappedProductTextThickness(textThicness) {
    var styles = {};
    switch(textThicness){
        case "thin":
            styles.fontWeight = "300";
            break;
        case "regular":
            styles.fontWeight = "400";
            break;
        case "medium":
            styles.fontWeight = "500";
            break;
        case "semiBold":
            styles.fontWeight = "600";
            break;
        case "bold":
            styles.fontWeight = "700";
            break;
        default:
            styles.fontWeight = "400";
            break;
    }
    return styles;
}
function getMappedProductCasing(titleTextCase) {
    var style = {};
    switch(titleTextCase){
        case "none":
            style.textTransform = "none";
            break;
        case "capitalize":
            style.textTransform = "capitalize";
            break;
        case "uppercase":
            style.textTransform = "uppercase";
            break;
    }
    return style;
}
function getTextSizeNum(sizeString) {
    var textSizeStr = getMappedproductsTextSize(sizeString).fontSize;
    return Number(textSizeStr.replace("px", ""));
}
function commonApiHeader(authToken) {
    return {
        headers: {
            auth_token: authToken,
            app_os: "cfe",
            app_version: "0.1.0",
            "Content-Type": "application/json"
        }
    };
}


/***/ }),

/***/ 50722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useLoadVisibleReel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

function useLoadVisibleReel(param) {
    var videoRef = param.videoRef, reelIndex = param.reelIndex, setLoadVideo = param.setLoadVideo, loadVideo = param.loadVideo;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (videoRef[reelIndex]) {
            var loadMoreCallback = function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        setLoadVideo(true);
                        observer.unobserve(entry.target);
                    }
                });
            };
            var observer;
            if (!loadVideo) {
                observer = new IntersectionObserver(loadMoreCallback, {
                    root: null,
                    rootMargin: "0px",
                    threshold: 0.01
                });
                observer.observe(videoRef[reelIndex]);
            } else {
                observer === null || observer === void 0 ? void 0 : observer.unobserve(videoRef[reelIndex]);
            }
            return function() {
                videoRef[reelIndex] && (observer === null || observer === void 0 ? void 0 : observer.unobserve(videoRef[reelIndex]));
            };
        }
    }, []);
    return null;
}


/***/ }),

/***/ 897713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pi": function() { return /* binding */ parseFormattedDate; },
/* harmony export */   "YZ": function() { return /* binding */ convertTo12HourFormat; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(730381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

function formatDate(date) {
    return moment__WEBPACK_IMPORTED_MODULE_0___default()(date).format("Do MMMM, YYYY");
}
function parseFormattedDate(formattedDate) {
    if (!formattedDate) {
        return null;
    }
    var date = moment__WEBPACK_IMPORTED_MODULE_0___default()(formattedDate, "Do MMMM, YYYY", true);
    return date.isValid() ? date.toDate() : null;
}
function convertTo12HourFormat(time24) {
    return moment__WEBPACK_IMPORTED_MODULE_0___default()(time24, "HH:mm").format("h:mm A");
}


/***/ }),

/***/ 179220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ GlobalCfeLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _globalLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(325480);


var GlobalCfeLoader = function(param) {
    var type = param.type, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_globalLoader__WEBPACK_IMPORTED_MODULE_1__/* .GlobalLoader */ .k, {
        type: type,
        color: color
    });
};


/***/ }),

/***/ 325480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ GlobalLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(185134);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(798388);
/* harmony import */ var src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(326706);
/* harmony import */ var src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965700);







var GlobalLoader = function(props) {
    var type = props.type, color = props.color;
    var store = (0,src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.documentElement.style.setProperty("--loader-color", color);
    }, [
        color
    ]);
    switch(type){
        case "logo1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo1)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "logo2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo2)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "loader1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    version: "1.1",
                    id: "L9",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "65px",
                    height: "65px",
                    viewBox: "0 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: color,
                        d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            dur: "1s",
                            from: "0 50 50",
                            to: "360 50 50",
                            repeatCount: "indefinite"
                        })
                    })
                });
            }
        case "loader2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L5",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 15 ; 0 -15; 0 15",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "30",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 10 ; 0 -10; 0 10",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "54",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader3":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader3), "tw-h-[35px] tw-w-[35px]")
                });
            }
        case "loader4":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L4",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "26",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "46",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader5":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader5), "tw-h-[16px] tw-w-[35px]")
                });
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
            }
    }
};


/***/ }),

/***/ 185134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo1":"globalLoader_logo1__U4pxQ","logo-1":"globalLoader_logo-1__07zYZ","logo2":"globalLoader_logo2__eivVl","loader-3":"globalLoader_loader-3__8hklP","loader3":"globalLoader_loader3__m47Bj","loader5":"globalLoader_loader5__6NXRf","loader-5-1":"globalLoader_loader-5-1__pESNT","loader-5-2":"globalLoader_loader-5-2__VgxuZ"};

/***/ })

}]);